import {useState, useEffect} from 'react';
import Container from '../common/layout/Container';
import {useTranslation} from 'react-i18next';

const timeout = 1000;
const logoutCounter = 5;

const LogoutMessage = ({instance} ) => {
  const {t} = useTranslation('common');
  const [count, setCount] = useState(logoutCounter);

  useEffect(() => {
    const timer = setTimeout(() => {
      const currentCount = count - 1;
      setCount(currentCount);
    }, timeout);

    if (!count) {
      clearTimeout(timer);
      instance.logout();
    }
  }, [count]);

  return (
    <Container header={t('notEnoughPermissionsHeader')}>
      <p className="error">
        {t('notEnoughPermissionsSubheader', {count})}
      </p>
    </Container>
  );
};

export default LogoutMessage;
